export enum AutocompleteType {
  ActionEnvVarKeys = "actionEnvVarKeys",
  ActionMetadataKeys = "actionMetadataKeys",
  ActionTags = "actionTags",
  CollectionTags = "collectionTags",
  DatasetMetadataKeys = "datasetMetadataKeys",
  DatasetTags = "datasetTags",
  EventMetadataKeys = "eventMetadataKeys",
  EventNames = "eventNames",
  EventTags = "eventTags",
  FileMetadataKeys = "fileMetadataKeys",
  FileTags = "fileTags",
  GenericMetadataKeys = "genericMetadataKeys",
  GenericTags = "genericTags",
  SessionMetadataKeys = "sessionMetadataKeys",
  SessionTags = "sessionTags",
  TopicMetadataKeys = "topicMetadataKeys",
}
